export default __webpack_public_path__ + "static/media/wave-thumbnail.e7b5fc99.svg";